module.exports = __webpack_public_path__ + "img/scroll.fe4feb68.svg";